import LogoutPage from './logout-page';

export default LogoutPage;